import { WorkInterventionsRepository } from "@/api/Repositories";
import options from "./interventions/options"
import days from "./interventions/days"
import workBlocks from "./interventions/workBlocks"
import shutDownBlocks from "./interventions/shutDownBlocks"
import timeWorkedPerDamage from "./interventions/timeWorkedPerDamage"
import usedMaterials from "./interventions/usedMaterials"
import usedSpareParts from "./interventions/usedSpareParts"
import generatedWastes from "./interventions/generatedWastes"
import repairStages from "./interventions/repairStages"
import bladePanoramicImages from "./interventions/bladePanoramicImages"
import bladeDamageIsInBladeZones from "./interventions/bladeDamageIsInBladeZones"
import bladeZones from "./interventions/bladeZones"
import bladeDamages from "./interventions/bladeDamages"
import bladeDamageSimilars from "./interventions/bladeDamageSimilars"

export default {
  namespaced: true,
  modules: {
    options,
    days,
    workBlocks,
    shutDownBlocks,
    timeWorkedPerDamage,
    usedMaterials,
    usedSpareParts,
    generatedWastes,
    repairStages,
    bladePanoramicImages,
    bladeDamageIsInBladeZones,
    bladeZones,
    bladeDamages,
    bladeDamageSimilars
  },
  state: {
    list: [],
    item: {}
  },
  mutations: {
    list (state, data) {
      state.list = []
      state.list = data
    },
    item (state, data) {
      state.item = {}
      state.item = data
    },
  },
  actions: {
    // Interventions
    list ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        WorkInterventionsRepository.getAll(obj)
          .then(response => {
            const data = response.data.data
            commit('list', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    get ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        WorkInterventionsRepository.get(obj)
          .then(response => {
            const data = response.data.data
            commit('item', data)
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    create (context, obj) {
      return new Promise((resolve, reject) => {
        WorkInterventionsRepository.create(obj)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    edit (context, obj) {      
      return new Promise((resolve, reject) => {
        WorkInterventionsRepository.update(obj)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    delete (context, obj) {
      return new Promise((resolve, reject) => {
        WorkInterventionsRepository.delete(obj)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    },
    changeState (context, obj) {      
      return new Promise((resolve, reject) => {
        WorkInterventionsRepository.changeState(obj)
          .then(() => {
            resolve();
          }).catch(errorChange => {
            reject(errorChange);
          });
      });
    },
  },
}
